/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Backdrop, CircularProgress } from '@mui/material';
import { Grid, Typography } from '@material-ui/core';
import { Country, State } from 'country-state-city';
// import { sign_up } from '../../shared/api/url-helper';
import '../../styles/sign-up.scss';
import { circle_right, signup_background, veolia_header } from '../../shared/assets/images';
import { defaultModalOptions } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { decrypt_data } from '../../shared/utils';
import { VerifyEmail } from '../../shared/api/url-helper';

const emailRegex = /[a-zA-Z0-9]+@[a-zA-Z]+\.[a-zA-Z]{2,3}/;
const Signup = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [otpVarified, setOtpVarified] = useState(false);
  const [emailValidate, setEmailValidate] = useState(false);
  const [disabledInput, setDisabledInput] = useState(false);
  const [otpValidate, setOtpValidate] = useState(false);
  const [otpData, setOtpData] = useState({});

  const [selectedCountry, setSelectedCountry] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [stateFlag, setStateFlag] = useState(true);
  const [loading, setLoading] = useState(false);

  const [authData, setAuthData] = useState({
    first_name: '',
    last_name: '',
    phone_number: '',
    email: '',
    country: '',
    state: '',
    company_name: '',
    job_title: '',
    industry: '',
    first_lander: 'no',
    equipment_owner: 'yes',
    comments: '',
    password: '',
    policy_accepted: false
  });

  // const env_xApiKey = process.env.REACT_APP_X_API_KEY;
  // const xApiKey = decrypt_data(env_xApiKey);
  // validation layer start
  const [touchedFields, setTouchedFields] = useState({});
  const { first_name, last_name, phone_number, email, country, state, company_name, industry, comments } = authData;

  // notification state management
  const [modalOption, setModalOption] = useState(defaultModalOptions);

  const handleBlur = (e) => {
    const { name, id } = e.target;
    setTouchedFields({
      ...touchedFields,
      [name || id]: true,
    });
  };

  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      type
    });
  };

  const generateRandomPassword = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let password = '';
    for (let i = 0; i < 8; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return password;
  };

  const randomPassword = generateRandomPassword();

  const handleSubmit = async (event) => {
    authData.password = randomPassword;
    let flag = false;
    setLoading(true);
    const validate_data = ['first_name', 'last_name', 'email', 'country', 'state', 'job_title', 'industry', 'first_lander', 'equipment_owner', 'policy_accepted'];
    validate_data.forEach((ele) => {
      if (!authData[ele] || authData[ele] === '') {
        if (document.querySelector(`[name="${ele}"]`)) {
          flag = true;
          document.querySelector(`[name="${ele}"]`).classList.add('error-input');
        }
      }
      if (ele === 'email' && authData[ele] !== '') {
        if (!emailRegex.test(authData[ele])) {
          flag = true;
          document.querySelector(`[name="${ele}"]`).classList.add('error-input');
        }
      }
    });
    event.preventDefault();
    if (!flag && otpData.exists) {
      openModelPopUp('Email id is already registered.', 'Warning!', 'warning');
    } else if (!flag && !otpVarified) {
      openModelPopUp('Please click on "Validate" to proceed with sign-up.', 'Warning!', 'warning');
    } else if (!flag) {
      const copyauthData = { ...authData };
      const countryData = selectedCountry.filter((ele) => {
        return ele.value === copyauthData.country;
      });
      if (countryData.length > 0) {
        copyauthData.country = countryData[0].label;
      }
      if (selectedState.length > 0) {
        const stateData = selectedState.filter((ele) => {
          return ele.value === copyauthData.state;
        });
        if (stateData.length > 0) {
          copyauthData.state = stateData[0].label;
        }
      }
      copyauthData.flag = 'signup_validation'; // adding this flag to differenciate the call in lambda
      // sign_up(copyauthData)
      // await axios({
      //   method: 'post',
      //   // url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/sign_up', // old one
      //   // url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/win_signUp',
      //   url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/verifyEmail', // changes to new lambda as we were gettin CROS issue
      //   headers: {
      //     'x-api-key': process.env.REACT_APP_X_API_KEY
      //   },
      //   data: copyauthData
      // })
      VerifyEmail(copyauthData)
        .then(async () => {
          openModelPopUp('Request for Approval has been sent to admin.', 'Success!', 'success');
        }).catch((error) => {
          openModelPopUp('Request for Approval Failed.', 'Error', 'error');
          console.error('Error posting data:', error);
        });
    }
    setLoading(false);
  };
  const handleChange = (e, str) => {
    const { name, value } = e.target;
    if (name === 'policy_accepted') {
      setAuthData({ ...authData, [name]: e.target.checked });
    } else {
      setAuthData({ ...authData, [name]: value });
    }

    if (['first_name', 'last_name', 'country', 'state', 'job_title', 'industry', 'policy_accepted'].indexOf(name) >= 0 && value.trim() === '') {
      if (str === 'policy_accepted') {
        document.querySelector(`[name="${name}"]`).classList.remove('error-input');
      } else if (document.querySelector(`[name="${name}"]`)) {
        document.querySelector(`[name="${name}"]`).classList.add('error-input');
      }
    } else if (name === 'email') {
      if (!emailRegex.test(value)) {
        setEmailValidate(false);
        document.querySelector(`[name="${name}"]`).classList.add('error-input');
      } else {
        setEmailValidate(true);
        document.querySelector(`[name="${name}"]`).classList.remove('error-input');
      }
    } else {
      document.querySelector(`[name="${name}"]`).classList.remove('error-input');
    }

    if (str === 'country') {
      let data = State?.getStatesOfCountry(value);
      data = data.map((ele) => {
        return { value: ele.isoCode, label: ele.name };
      });
      if (value === '' || data.length > 0) {
        setStateFlag(true);
      } else {
        setStateFlag(false);
      }
      setSelectedState(data);
    }
  };
  const validateEmail = async () => {
    setDisabledInput(true);
    setShowLoader(true);
    // await axios({
    //   method: 'post',
    //   url: 'https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/verifyEmail',
    //   headers: {
    //     'x-api-key': process.env.REACT_APP_X_API_KEY
    //   },
    //   data: { email: authData.email, 'flag' : 'email_validation'} // adding this otp flag to differenciate the call in lambda
    // })
    VerifyEmail({ email: authData.email, 'flag' : 'email_validation'})
      .then(async (response) => {
        setShowLoader(false);
        response.data = JSON.parse(response.data.body);  // new response body in string fixed by Abhishek : 30-6-25
        setOtpData(response.data);
        if (response.data.exists) {
          setDisabledInput(false);
          openModelPopUp('Email id is already registered.', 'Warning!', 'warning');
        } else if (!response.data.exists) {
          setOtpValidate(true);
        }
      })
      .catch((error) => {
        setDisabledInput(false);
        setShowLoader(false);
        openModelPopUp('Something went wrong', 'Error', 'error');
        console.error('Error posting data:', error);
      });

  };
  const inputValue = (e, index) => {
    const inputs = document.querySelectorAll('input.otp');
    if (e.target.value.length > 1) {
      e.target.value = e.target.value.slice(0, 1);
    }
    if (e.target.value.length === 1) {
      if (index < inputs.length - 1) {
        inputs[index + 1].focus();
      }
    }
    inputs[index].classList.remove('error-input');
  };
  const keydown = (e, index) => {
    const inputs = document.querySelectorAll('input.otp');
    if (e.key === 'Backspace' && !e.target.value) {
      if (index > 0) {
        inputs[index - 1].focus();
      }
    }
    if (e.key === 'e') {
      e.preventDefault();
    }
  };
  const matchOtp = () => {
    let str = '';
    let flag = true;
    const inputs = document.querySelectorAll('input.otp');
    inputs.forEach((ele) => {
      if (ele.value !== '') {
        ele.classList.remove('error-input');
        str += ele.value.toString();
      } else {
        ele.classList.add('error-input');
        flag = false;
      }
    });
    if (flag && str === otpData.otp) {
      setOtpVarified(true);
      setOtpValidate(false);
      setEmailValidate(false);
    } else {
      openModelPopUp('The OTP entered is incorrect.', 'Warning!', 'warning');
    }
  };
  useEffect(() => {
    document.querySelectorAll('[name="first_lander"]')[1].checked = true;
    document.querySelectorAll('[name="equipment_owner"]')[0].checked = true;
  }, []);
  useEffect(() => {
    const data = Country.getAllCountries().map((ele) => {
      return { value: ele.isoCode, label: ele.name };
    });
    setSelectedCountry(data);
  }, []);
  return (
    <div>
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        style={{
          background: '#d9dbde5c',
        }}>
        <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
      </Backdrop>
      <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
      <img src={signup_background} style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', objectFit: 'cover' }} />
      <img className='h-100' align="left" src={veolia_header} style={{ marginLeft: '48px', height: '40px', marginTop: '24px', position: 'fixed', zIndex: 1 }} />
      <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 1, right: 0, margin: 'auto', width: '450px', padding: '30px 0' }}>
        <div className='sign-up-mainpage'>
          <div className='sign-up-outer' style={{ alignItems: 'center' }}>
            <form onSubmit={handleSubmit}>
              <Grid item xs={8} className="rufusReg f14 mx-100 ">
                <p className='text-label-signup XL_heading' style={{ marginBottom: '8px' }}>Sign up</p>
                <p className='text-label-signup S_Regular' style={{ marginBottom: '8px' }}>Please fill all the details</p>
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 justify-content mt-15">
                <Grid item xs={6} className="rufusReg f14" style={{ marginRight: 10 }}>
                  <p className='text-label-signup S_Regular'>First Name <span style={{ color: 'red' }}>*</span></p>
                  <input
                    className='input-border input-sineup'
                    id="outlined-basic_f_name"
                    name="first_name"
                    type="text"
                    onChange={(e) => { handleChange(e, 'first_name'); }}
                    onBlur={(e) => { handleBlur(e, 'first_name'); }}
                    value={first_name}
                  />
                </Grid>
                <Grid item xs={6} className="rufusReg f14">
                  <p className='text-label-signup S_Regular'>Last Name <span style={{ color: 'red' }}>*</span></p>
                  <input
                    className='input-border input-sineup'
                    id="outlined-basic_l_name"
                    name="last_name"
                    type="text"
                    onChange={(e) => { handleChange(e, 'last_name'); }}
                    onBlur={(e) => { handleBlur(e, 'last_name'); }}
                    value={last_name}
                  />
                </Grid>
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <p className='text-label-signup S_Regular'>Phone Number</p>
                <input
                  className='input-border input-sineup'
                  id="outlined-basic_phone_no"
                  name="phone_number"
                  type="number"
                  onChange={(e) => { handleChange(e, 'phone_number'); }}
                  onBlur={(e) => { handleBlur(e, 'phone_number'); }}
                  value={phone_number}
                />
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <p className='text-label-signup S_Regular'>Email <span style={{ color: 'red' }}>*</span></p>
                <div className={`email-text ${!disabledInput ? '' : 'disabled'}`}>
                  <input
                    className={`input-border input-sineup ${emailValidate ? 'input-space' : ''} ${otpVarified ? 'success-border' : ''}`}
                    id="outlined-basic_email"
                    name="email"
                    type="email"
                    onChange={(e) => { handleChange(e, 'email'); }}
                    onBlur={(e) => { handleBlur(e, 'email'); }}
                    value={email}
                  />
                  {showLoader && (<div className="loader-section">
                    <span className="loader" />
                  </div>
                  )}
                  {emailValidate && <span className='validate-email' onClick={validateEmail}>Validate</span>}
                </div>
                {otpVarified && (<div className="S_Regular success"><img src={circle_right} style={{ width: 15, marginRight: 5 }} /><span>Successfully Validated!</span></div>)}
              </Grid>
              {otpValidate && (
                <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                  <p className='text-label-signup S_Regular S_Bold'>Enter the OTP send via mail to validate</p>
                  <div className='email-text'>
                    {(() => {
                      return [0, 1, 2, 3, 4, 5].map((ele, index) => {
                        return (
                          <input type="number" min="0" max="9" required className='input-border input-sineup otp' onInput={(e) => { inputValue(e, index); }} onKeyDown={(e) => { keydown(e, index); }} />
                        );
                      });
                    })()}
                    <div className='btn-width S_Bold' onClick={matchOtp}>Submit OTP</div>
                  </div>
                </Grid>
              )}
              <Grid item xs={8} className="rufusReg f14 mx-100 justify-content mt-15">
                <Grid item xs={6} className="rufusReg f14 mxflex-100" style={(stateFlag || selectedState.length > 0) ? { marginRight: 10 } : {}}>
                  <p className='text-label-signup S_Regular'>Country <span style={{ color: 'red' }}>*</span></p>
                  <select value={country} className='input-border input-sineup' name='country' onChange={(e) => { handleChange(e, 'country'); }}>
                    <option value=''>Select</option>
                    {(selectedCountry || []).map((ele) => {
                      return <option value={ele.value}>{ele.label}</option>;
                    })}
                  </select>
                </Grid>
                {(stateFlag || selectedState.length > 0) && (
                  <Grid item xs={6} className="rufusReg f14 mxflex-100">
                    <p className='text-label-signup S_Regular'>State <span style={{ color: 'red' }}>*</span></p>
                    <select value={state} className='input-border input-sineup ' name='state' onChange={(e) => { handleChange(e, 'state'); }}>
                      <option value=''>Select</option>
                      {(selectedState || []).map((ele) => {
                        return <option value={ele.value}>{ele.label}</option>;
                      })}
                    </select>
                  </Grid>
                )}
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <p className='text-label-signup S_Regular'>Company</p>
                <input
                  className='input-border input-sineup'
                  id="outlined-basic_company"
                  name="company_name"
                  type="text"
                  onChange={(e) => { handleChange(e, 'company_name'); }}
                  onBlur={(e) => { handleBlur(e, 'company_name'); }}
                  value={company_name}
                />
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <p className='text-label-signup S_Regular'>Job-Title <span style={{ color: 'red' }}>*</span></p>
                <select className='input-border input-sineup' name='job_title' onChange={(e) => { handleChange(e, 'job_title'); }}>
                  <option value="">Select...</option>
                  <option value='Product Application Specialist'>Product Application Specialist</option>
                  <option value='Engineering Manager'>Engineering Manager</option>
                  <option value='Account Manager'>Account Manager</option>
                  <option value='ES Manager'>ES Manager</option>
                  <option value='Field Manager'>Field Manager</option>
                  <option value='Sales Manager'>Sales Manager</option>
                  <option value='Product Manager'>Product Manager</option>
                  <option value='Lead Engineer'>Lead Engineer</option>
                  <option value='Chemical Engineer'>Chemical Engineer</option>
                  <option value='Field Engineer'>Field Engineer</option>
                  <option value='Process Engineer'>Process Engineer</option>
                  <option value='Customer'>Customer</option>
                  <option value='Student'>Student</option>
                </select>
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <p className='text-label-signup S_Regular'>Industry <span style={{ color: 'red' }}>*</span></p>
                <select value={industry} className='input-border input-sineup' name='industry' onChange={(e) => { handleChange(e, 'industry'); }}>
                  <option value="">Select...</option>
                  <option value="Chemical Processing">Chemical Processing </option>
                  <option value="Dairy">Dairy</option>
                  <option value="Food and Beverage">Food and Beverage</option>
                  <option value="General Manufacturing">General Manufacturing</option>
                  <option value="Hydrocarbon Processing">Hydrocarbon Processing</option>
                  <option value="Microelectronics">Microelectronics </option>
                  <option value="Mining">Mining</option>
                  <option value="Municipal/Government">Municipal/Government</option>
                  <option value="Pharmaceutical">Pharmaceutical</option>
                  <option value="Power">Power </option>
                  <option value="Primary Metals/Steel/Aluminum">Primary Metals/Steel/Aluminum </option>
                  <option value="Pulp &amp; Paper">Pulp &amp; Paper </option>
                  <option value="Upstream Oil &amp; Gas">Upstream Oil &amp; Gas </option>
                </select>
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <span className='text-label-signup S_Regular'>Are you using Winflows for the first time?</span>
                <div style={{ display: 'flex', marginTop: 5 }}>
                  <Grid xs={2} className='justify-content'>
                    <input onChange={(e) => { handleChange(e, 'first_lander'); }} type="radio" id="first_yes" name="first_lander" value="yes" style={{ marginRight: 5 }} />
                    <label htmlFor="first_yes" className='text-label-signup S_Regular'>Yes</label>
                  </Grid>
                  <Grid xs={2} className='justify-content'>
                    <input onChange={(e) => { handleChange(e, 'first_lander'); }} type="radio" id="first_no" name="first_lander" value="no" style={{ marginRight: 5 }} />
                    <label htmlFor="first_no" className='text-label-signup S_Regular'>No</label>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <span className='text-label-signup S_Regular'>Do you manufacture, design or assemble RO/NF equipment?</span>
                <div style={{ display: 'flex', marginTop: 5 }}>
                  <Grid xs={2} className='justify-content'>
                    <input onChange={(e) => { handleChange(e, 'equipment_owner'); }} type="radio" id="equipment_yes" name="equipment_owner" value="yes" style={{ marginRight: 5 }} />
                    <label htmlFor="equipment_yes" className='text-label-signup S_Regular'>Yes</label>
                  </Grid>
                  <Grid xs={2} className='justify-content'>
                    <input onChange={(e) => { handleChange(e, 'equipment_owner'); }} type="radio" id="equipment_no" name="equipment_owner" value="no" style={{ marginRight: 5 }} />
                    <label htmlFor="equipment_no" className='text-label-signup S_Regular'>No</label>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <p className='text-label-signup S_Regular'>Any Comments</p>
                <input
                  className='input-border input-sineup'
                  id="outlined-basic_any_comments"
                  name="comments"
                  type="text"
                  onChange={(e) => { handleChange(e, 'comments'); }}
                  onBlur={(e) => { handleBlur(e, 'comments'); }}
                  value={comments}
                />
              </Grid>
              <Grid item xs={8} className="rufusReg f14 mx-100 mt-15">
                <div className="remember sansW4SeLig" style={{ alignItems: 'flex-start' }}>
                  <input onChange={(e) => { handleChange(e, 'policy_accepted'); }} type="checkbox" id="policy_accepted" name="policy_accepted" value='' style={{ margin: '2px 10px 0 0' }} />
                  <label htmlFor="policy_accepted" style={{ textAlign: 'justify' }}>
                    {/* I have read and agree to the Veolia Water Technologies & Solutions Privacy Policy and I would like to receive email updates about products, services and events. Please note, consent can be withdrawn at any time by clicking here. */}
                    I have read and agree to the Veolia Water Technologies & Solutions <a style={{ textDecoration: 'none', color: '#0062A9' }} href='https://www.watertechnologies.com/terms#privacypolicyterms' rel="noreferrer" target='_blank'>Privacy Policy</a> and I would like to receive email updates about products, services and events.
                  </label>
                </div>
              </Grid>
              <Grid item style={{ marginTop: '32px', textAlign: 'center' }}>
                <input id='submit' style={{ width: 125 }} type='submit' value='Sign up' className="M_Bold Primary_Default_Button submit-button  " />
              </Grid>
              <Grid item style={{ marginTop: '20px', textAlign: 'center' }}>
                <p className="sansW4SeLig S_Regular ntregisterYet">Already Signed Up with these details ? Then
                  <a href="/sign-in" className="ntregister sansW6SeBld M_Regular">Login</a></p>
              </Grid>
              <Grid item style={{ marginTop: '10px' }} >
                <Typography
                  variant="body2"
                  align="center"
                  className="footerLogin S_Regular forground-text-secondary-WithoutHover">
                  powered by @Veolia
                </Typography>
              </Grid>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Signup;
